import { Component, OnInit } from '@angular/core';
import { MatRadioChange } from '@angular/material';
import {
  FormGroup,
  FormArray,
  FormBuilder,
  Validators,
  FormControlName,
  Form,
  FormGroupName,
  AbstractControl
} from '@angular/forms';
import { Reservation, ReservationSubItem } from '../../../model/reservation.model';
import { ReservationService } from '../../../service/reservation.service';
import { DialogService } from '../../../service/dialog.service';
import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { SportType } from 'src/app/model/sport-type.model';
import { User } from 'src/app/model/user.model';
import { AuthService } from 'src/app/service/auth.service';
import { ReservationStatus } from 'src/app/model/reservation-status.model';
import { LessonType } from 'src/app/model/lesson-type.model';
import { Instructor } from 'src/app/model/instructor.model';
import {  DataService } from 'src/app/service/data.service';
import { PaymentService } from 'src/app/service/payment.service';
import { Role } from 'src/app/model/role.model';
import { TranslationPipe } from 'src/app/pipes/translation.pipe';
import { addDays } from 'date-fns';
import { Grouptype } from 'src/app/model/grouptype';
import { Pricelist } from 'src/app/model/pricelist';

@Component({
  selector: 'app-equipment-add',
  templateUrl: './equipment-add.component.html',
  styleUrls: ['./equipment-add.component.css']
})
export class EquipmentAddComponent implements OnInit {
    constructor(
      private fb: FormBuilder,
      reservationService: ReservationService,
      private datePipe: DatePipe,
      private router: Router,
      dialogService: DialogService,
      private authService: AuthService,
      private dataService: DataService,
      private paymentService: PaymentService,
      private translationPipe: TranslationPipe) {
      this.reservationService = reservationService;
      this.dialogService = dialogService;
      this.authService.currentUser.subscribe(x => {this.currentUser = x;});
    }
  
    reservationService: ReservationService;
    dialogService: DialogService;
    reservationFormGroup: FormGroup;
  
    TotalRow: number;
    Reservation: Reservation;
    forma: any;
    valid: Validators;
    public UserName = '';
    startDate: Date;
    endDate: Date;
    maxDate : Date;
    inputReadonly = true;
    selectedIndex: number;
    selectedItemFormGroup: AbstractControl;
    link: string;
    reservationStatuses: ReservationStatus[];
    minDate: Date;
    groupTypes: Grouptype[];
    equipmentTypes : Pricelist[];
    currentUser: User;
  
    ngOnInit(): void {
      this.dataService.getGroupTypes().subscribe(data => {
        this.groupTypes = data as Grouptype[];    
      });
      this.reservationFormGroup = this.fb.group({
        selectedItem: [],
        dateFrom: ['', Validators.required],
        dateTo: ['', Validators.required],
        TermsAndConditions: [false],
        reservationFormItemRows: this.fb.array([])
      });
      this.minDate = new Date();
      this.startDate = this.reservationFormGroup.value.dateFrom.value==null? new Date(): this.reservationFormGroup.value.dateFrom;
      this.Reservation = new Reservation();
      this.link = '/terms-and-conditions';
      this.AddReservation();
      
    }
  
    selectItem(index: number) {
      if(this.reservationItems.length>1 && this.reservationItems.controls[this.selectedIndex] && this.reservationItems.controls[this.selectedIndex].value.name==''){
        this.RemoveReservation(this.selectedIndex);
      
   
      }
      if(this.reservationItems.controls[index] && this.reservationItems.controls[index].value.name!=''){
        this.dataService.getEquipmentTypesByGroupType(this.reservationItems.controls[index].value.groupType).subscribe(data => {
          this.equipmentTypes = data as Pricelist[];    
        });
      }

      
      this.selectedItemFormGroup = this.reservationItems.controls[index];
      this.selectedIndex = index;
    }
  
    changeEventFrom(event) {
      this.startDate = this.reservationFormGroup.value.dateFrom;
      this.maxDate=addDays(this.startDate, 6)
    }
  
    changeEventTo(event) {
      var min=addDays(this.reservationFormGroup.value.dateTo, -6);
      (min>new Date()?this.minDate=addDays(this.reservationFormGroup.value.dateTo, -6): this.minDate = new Date());
      this.endDate = this.reservationFormGroup.value.dateTo;
    }

    getNumberOfDays(){
      return (this.reservationFormGroup.value.dateTo.getTime() - this.reservationFormGroup.value.dateFrom.getTime())/(1000 * 60 * 60 * 24) + 1;;
    }
  
    public toggleInputReadonly() {
      this.inputReadonly = !this.inputReadonly;
    }
  
    initReservationItems() {
      return this.fb.group({
        name: ['', Validators.required],
        lastName: ['', Validators.required],
        age: ['', Validators.required],
        height: ['', Validators.required],
        weight: ['', Validators.required],
        place: ['', Validators.required],
        skillLevel: ['0', Validators.required],
        groupType: ['', Validators.required],
        equipmentType :['', Validators.required]       
      });
    }
    get reservationItems() {
      return this.reservationFormGroup.get(
        'reservationFormItemRows'
      ) as FormArray;
    }
  
    AddReservationClick() {
      if (!this.reservationItems.valid) {
        this.dialogService.showMessage(
          this.translationPipe.transform('lblReservationAddInvalidData'),
          this.translationPipe.transform('msgReservationAddMandatoryFieds'),
        );
        return;
      }
      this.AddReservation();
    }
  
    AddReservation() {
      this.reservationItems.push(this.initReservationItems());
      this.selectItem(this.reservationItems.controls.length - 1);
      this.selectedIndex = this.reservationItems.controls.length - 1;
    }
  
    RemoveReservation(index: number) {
      if (this.reservationItems != null) {
        this.TotalRow = this.reservationItems.value.length;
      }

      if(this.reservationItems.controls[index].value.name==''){
        this.reservationItems.removeAt(index);
        this.selectItem(this.reservationItems.controls.length - 1);
        return;
      }
      
      if (this.TotalRow > 1) {
        const selected =  this.reservationItems.value[index];
        const msg = selected ? ((selected.name ? selected.name : '') + ' ' +  (selected.lastName ? selected.lastName : '')) : '';
        this.dialogService.showConfirmDialog(this.translationPipe.transform('lblDelete'), msg).subscribe(res => {
          if (res) {
            this.reservationItems.removeAt(index);
            this.selectItem(this.reservationItems.controls.length - 1);
          }});
      } else {
        alert(this.translationPipe.transform('lblReservationAddCanNotDelete'));
        return false;
      }
    }
  
    setNameLastName(index: number): string {
      let name = this.reservationItems.value[index].name;
      if (name == null || name === '') {
        return '...';
      } else {
        name =
          this.reservationItems.value[index].name +
          ' ' +
          this.reservationItems.value[index].lastName;
      }
      return name;
    }
  
    SendReservationRequest() {
      if (this.CheckValidation()) {
        this.CreateReservation();
        if (this.isPaymentVisible) {
            this.router.navigateByUrl('/payment-init', { state: { reservation: this.Reservation } });
        } else {
          this.reservationService.CreateReservation(this.Reservation).subscribe(
          res => {
              this.dialogService.showMessageWithCallback(
                this.translationPipe.transform('lblReservationAddRequestSent'),
                this.translationPipe.transform('msgReservationAddRequestSent'),
                () => {
                  this.referesh();
                });
          },
          (err: HttpErrorResponse) => {})
        }
      }
    }

    changeEquipmentType(grouptype){
      this.dataService.getEquipmentTypesByGroupType(grouptype).subscribe(data => {
        this.equipmentTypes = data as Pricelist[];    
      });
    }
  
    referesh() {
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigateByUrl('/');
    }
  
    CheckValidation(): boolean {
      if (this.reservationFormGroup.validator) {
        this.dialogService.showMessage(
          this.translationPipe.transform('lblReservationAddInvalidData'),
          this.translationPipe.transform('msgReservationAddInvalidAge')
        );
        return false;
      }
      if (this.reservationItems.length == 0) {
        this.dialogService.showMessage(
          this.translationPipe.transform('lblReservationAddInvalidData'),
          this.translationPipe.transform('msgReservationAddInvalidAddItems')
        );
        return false;
      }
      if (!this.reservationFormGroup.valid) {
        this.dialogService.showMessage(
          this.translationPipe.transform('lblReservationAddInvalidData'),
          this.translationPipe.transform('msgReservationAddMandatoryFieds')
        );
        return false;
      }
  
      if (!this.reservationFormGroup.value.TermsAndConditions) {
        this.dialogService.showMessage(
          this.translationPipe.transform('lblReservationAddInvalidData'),
          this.translationPipe.transform('msgReservationAddInvalidTermsAndConditions')
        );
        return false;
      } 
      return true;
    }
  
  
    CreateReservation() {
      this.Reservation = new Reservation();
      this.Reservation.user = this.authService.currentUserValue;
      this.Reservation.dateFrom = this.datePipe.transform(
        this.reservationFormGroup.value.dateFrom,
        'yyyy-MM-dd'
      );
      this.Reservation.dateTo = this.datePipe.transform(
        this.reservationFormGroup.value.dateTo,
        'yyyy-MM-dd'
      );
      this.Reservation.status = new ReservationStatus(0, 'created', 'created');
      this.Reservation.isLessonReservation=0;

      this.reservationItems.value.forEach(ri => {
        this.Reservation.reservationSubItems.push(
          new ReservationSubItem(
            ri.name,
            ri.lastName,
            ri.age,
            null,
            this.reservationService.getSkillLevels()[ri.skillLevel],
            null,
            null,
            null,
            null,
            0,
            this.groupTypes.filter(group=> group.id===ri.groupType)[0],
            this.getNumberOfDays(),
            ri.equipmentType,
            ri.height,
            ri.weight,
            ri.place
          )
        );
      });
    }
  
    get isAdmin() {
      return this.currentUser && this.currentUser.role === Role.Admin;
    }
  
  /*   get isPaymentVisible() {
      return this.currentUser.role === 'Admin' || this.currentUser.username === 'chipcardtest' || this.currentUser.username.endsWith('paymentTest');
    } */

    
  get isPaymentVisible() {
    return true;
  }
  }
